import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=a976b4a0&scoped=true&"
import script from "./restaurant.vue?vue&type=script&lang=js&"
export * from "./restaurant.vue?vue&type=script&lang=js&"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=a976b4a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a976b4a0",
  null
  
)

export default component.exports